import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-businessco-settings',
  templateUrl: './businessco-settings.component.html',
  styleUrls: ['./businessco-settings.component.css']
})
export class BusinesscoSettingsComponent implements OnInit {
    businessCoNo;

    public itemsListGroups: Item[] = [];

    constructor(private state: StateService, private datatask: DataTaskService) {
        this.businessCoNo = this.state.getStateParams()['businessco_no'];
    }

    private async loadSettingGroups(): Promise<void> {
        this.itemsListGroups = await this.datatask.Post(234, { businessco_no: this.businessCoNo });
    }

    private async init() {
        this.loadSettingGroups();
    }

    ngOnInit() {
        this.init();
    }
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('businesscoSettings', {
//        templateUrl: 'views/components/views/businesscoSettings/businesscoSettings.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'businesscoSettingsService', function ($stateParams, businesscoSettingsService) {
//            const vm = this;
//            let businessCoNo = $stateParams.businessco_no;

//            vm.model = {
//                itemsListGroups: []
//            };

//            async function loadSettingGroups() {
//                vm.model.itemsListGroups = await businesscoSettingsService.listSettingGroups({ businessco_no: businessCoNo });
//            }

//            vm.$onInit = function () {
//                loadSettingGroups();
//            }
//        }]
//    });
//})();
